module.exports = __webpack_public_path__ + "img/logoc.305daa95.png";